export default class ClientErrorException extends Error {
    constructor(message){
        super(message)
        this.name = this.constructor.name
    }
}